import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_91: FaireProductEntity = {
  token: "starter_collection_91",
  type: "product",
  name: "Ice Cream Scoop",
  brandName: "Material",
  imageUrl:
    "https://cdn.faire.com/fastly/9a8ab18491cc60f2fddd358dcc0b77b430cded0a0527b51cc5cd3a2ce60ebe06.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 32,
  msrpDollars: 64,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
